import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { LanguageProvider, useLanguage } from "@/lib/i18n/LanguageContext";
import { Layout } from "@/components/layout/Layout";
import { AnimatedRoutes } from "@/components/layout/AnimatedRoutes";
import { CookieConsent } from "@/components/layout/CookieConsent";
import { JsonLdSchema } from "@/components/seo/JsonLdSchema";
import { LegacyUrlNotice } from "@/components/layout/LegacyUrlNotice";

const queryClient = new QueryClient();

// Sitewide multilingual structured data — re-emits when the active language changes
const SitewideJsonLd = () => {
  const { language } = useLanguage();
  return (
    <>
      <JsonLdSchema type="organization" language={language} />
      <JsonLdSchema type="website" language={language} />
    </>
  );
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <LanguageProvider>
          <SitewideJsonLd />

          <LegacyUrlNotice />
          <Layout>
            <AnimatedRoutes />
          </Layout>
          <CookieConsent />
        </LanguageProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
